<template>
  <div class="select_wrap">
    <select v-model="internalValue" @change="onChange" :class="[fontStyle, size]" class="select">
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "" // Add default value
    },
    fontStyle: {
      type: String,
      default: "ab"
    },
    size: {
      type: String,
      default: "md"
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
    internalValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>


<style lang="css" scoped>
.select_wrap {
  border-bottom: 1px solid  #c9c9c9;
  /* padding-bottom: 10px; */
  position: relative;
}
.select {
  color: #5A5A5A;
  font-size: 16px;
  padding: 15px 15px 15px 0;
  width: 100%;
}
.select_wrap::after {
  align-items: center;
  bottom: 0;
  content: '\f078';
  color: #636366;
  display: flex;
  font-size: 18px;
  font-family: "Font Awesome 5 Free","Font Awesome 5 Brands";
  font-weight: 900;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}
.select.small {
  padding: 0 15px 8px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/BaseSelect.vue